import { t } from "i18next";
import { Languages, Mail, Trash2 } from "lucide-react";
import type { JSX } from "react";
import { AppConfig } from "@/common/appConfig";
import { InterfacePreferences } from "@/pages/Settings/AccountSettings/InterfacePreferences";
import {
  DeleteAccountAction,
  LoginDetails,
  NativeSignInEmail,
} from "@/pages/Settings/AccountSettings/LoginDetails";
import { SettingsCard } from "../redesign/SettingsCard";

export default function AccountTab(): JSX.Element {
  // v3.2: three calm cards (sign-in, display language, delete account).
  if (AppConfig.enableAppRedesign)
    return (
      <div className="flex flex-col gap-5 sm:gap-4">
        <SettingsCard
          icon={<Mail aria-hidden />}
          labelledBy="account-sign-in"
          testId="account-sign-in"
          title={t("settings.home.signIn")}
        >
          <NativeSignInEmail />
        </SettingsCard>
        <SettingsCard
          description={t("settings.account.interfacePreferences.hint")}
          icon={<Languages aria-hidden />}
          labelledBy="account-language"
          testId="account-language"
          title={t(
            "settings.account.interfacePreferences.interfaceLanguageLabel",
          )}
        >
          <InterfacePreferences />
        </SettingsCard>
        <SettingsCard
          description={t("settings.security.native.account.deleteHint")}
          icon={<Trash2 aria-hidden />}
          labelledBy="account-delete"
          testId="account-delete"
          title={t("settings.security.native.account.delete")}
          tone="danger"
        >
          <DeleteAccountAction />
        </SettingsCard>
      </div>
    );

  return (
    <section className="space-y-4">
      <div className="space-y-2">
        <div className="text-xl font-medium">{t("settings.title")}</div>
        <div className="border border-solid border-gray-200 p-4 rounded-md">
          <LoginDetails />
        </div>
      </div>
      <div className="space-y-2">
        <div className="text-xl font-medium">
          {t("settings.account.interfacePreferences.title")}
        </div>
        <div className="border border-solid border-gray-200 p-4 rounded-md">
          <InterfacePreferences />
        </div>
      </div>
    </section>
  );
}
